module.exports = "//docs.gtimg.com/slide/img/framework/workbench/ui/batch-handle-animation/pc_free_tag-38fdec.svg";